import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewWillEnter } from '@ionic/angular';
import { WorkOrderService } from '../../services/work-order.service';
import { RequestParams } from '../../../../common/rest-api/models/request-params';
import { WorkOrderSection } from '../../models/work-order-section.model';
import { StopKey } from '../../../../common/models/stop-key-model ';
import { GtrakAuthService } from '../../../authentication/services/gtrak-auth.service';
import { CostCenterKey } from '../../../../common/models/costCenter-key.model';
import _ from "lodash";

@Component({
  selector: 'app-recent-work-order-report-page',
  templateUrl: 'recent-work-order-report.page.html',
  styleUrls: [
    './recent-work-order-report.page.scss',
  ]
})
export class RecentWorkOrderReportPage implements ViewWillEnter, OnInit {

  stopCode: string;
  customerId: string;
  depKey: StopKey;
  requestParams: any;
  results: any;
  reports: WorkOrderSection[] = [];
  pageSize: number;
  currentPage: number;
  csKey: CostCenterKey;
  currentDate = new Date();
  costCenter:string;
  loaded: boolean = false;
  Dept:string;
  Emp:string;
  header:string;
  customerCode:string;
  customerName:string="";
  departmentName:string="";
  public viewChange: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private workOrderService: WorkOrderService,
    private router: Router,
    private authService: GtrakAuthService,
  ) { 

  }

  async ngOnInit(): Promise<void> {
    this.loaded=false;
    if(!this.authService.user.canViewWorkOrders) {
      this.router.navigate([this.authService.user.homeLocation]);
    }
     this.customerCode = this.route.snapshot.paramMap.get('customerId');

    this.currentPage = 1;
    this.pageSize = 0;
    this.requestParams = new RequestParams();

    this.requestParams.setOrdering('LastName', 'asc');
    this.requestParams.setPaging(this.currentPage, this.pageSize);
      this.csKey = {
      CustomerCode: this.customerId,
      DepartmentCode: "",
      EmployeeCode: "",
      CostCenterCode: this.costCenter
    };

   await this.setData();
        this.loaded=true;
  }

  ionViewWillEnter(): void {
   
  }

  changePrinterView(): void {
    this.viewChange = !this.viewChange;
    // Set a delay before opening the print dialog
    setTimeout(() => {
      print();
    }, 1000); // 2000 milliseconds = 2 seconds
  }

  async setData(): Promise<void> {
     if(this.authService.user.isCostCenterUser){
      var costCenterString =localStorage.getItem('costCenterString');
        if(costCenterString!=null && costCenterString!=""){
            this.requestParams.filters.CostCenter= costCenterString ;
        }
     }

    this.header='Recent Work Order Report';
    this.results = await this.workOrderService.getForCustomerWO(this.customerCode, this.requestParams);
   
      if ( this.results!=null && this.results.results.length>0 ){
          this.customerName=this.results.results[0].customerName;
           this.departmentName=this.results.results[0].departmentName;
           
            this.Dept=this.results.results[0].departmentCode;
      }

    _.each(this.results.results, (wo) => {
      if(!_.find(this.reports, ['employeeCode', wo.employeeCode])) {
        var section = new WorkOrderSection();
        var workOrdersList = [];

        workOrdersList.push(wo);

        section = {
          employeeCode: wo.employeeCode,
          departmentCode: wo.departmentCode,
          firstName: wo.firstName,
          lastName: wo.lastName,
          stop: wo.stopName,
          stopCode: wo.stopCode,
          workOrders: workOrdersList,
          deliveryAddress1:wo.deliveryAddress1,
          departmentName:wo.departmentName,
          customerName:wo.customerName
        }
        this.reports.push(section);
      } else {
        _.find(this.reports, ['employeeCode', wo.employeeCode]).workOrders.push(wo);
      }
    })

    this.loaded = true;
  }


}